export default __webpack_public_path__ + "static/media/shriya.df46f4ad.jpg";